import React from "react";
import { useParams } from "react-router";
import { useIsSmallScreen } from "../../App";
import { getLiturgicalYear, getMonthName } from "../../calendar/utils";
import { Padding } from "../../shared-components/Padding";
import { CalendarRow } from "./CalendarRow";

export const YearPage: React.FC<{}> = () => {
    const year = parseInt(useParams<{ year: string }>().year);

    const isSmallScreen = useIsSmallScreen();

    let prevMonth: number = 0;
    const rows = getLiturgicalYear(year, true).days.map((day) => {
        let monthDivider = <></>;
        if (prevMonth !== day.month) {
            prevMonth = day.month;
            monthDivider = (
                <div
                    style={{
                        paddingBottom: 8,
                        paddingTop: 48,
                        fontWeight: "bold",
                    }}
                    key={day.month}
                >
                    {getMonthName(day.month)}
                </div>
            );
        }

        return (
            <>
                {monthDivider}
                <CalendarRow day={day} />
            </>
        );
    });

    return <Padding>{rows}</Padding>;
};
